import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import SiteNavbar from '../SiteNavbar';
import SiteFooter from '../SiteFooter';
import './auth.css';

export default function ResetPassword() {
  const { token }    = useParams();
  const navigate     = useNavigate();

  const [password, setPassword]     = useState('');
  const [confirm, setConfirm]       = useState('');
  const [loading, setLoading]       = useState(false);
  const [success, setSuccess]       = useState('');
  const [error, setError]           = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      return setError('A senha deve ter pelo menos 6 caracteres.');
    }
    if (password !== confirm) {
      return setError('As senhas não coincidem.');
    }

    setLoading(true);
    try {
      const { data } = await api.post(`/auth/reset-password/${token}`, { password });
      setSuccess(data.message);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Link inválido ou expirado. Solicite um novo link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <SiteNavbar />
      <div className="auth-page">
        <div className="auth-card narrow">
          <h1 className="auth-title">Nova senha</h1>
          <p className="auth-subtitle">Escolha uma nova senha para a sua conta.</p>

          {error   && <div className="auth-error">{error}</div>}
          {success && (
            <div className="auth-success">
              {success}<br />
              <small>Você será redirecionado para o login em instantes...</small>
            </div>
          )}

          {!success && (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nova senha</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  autoFocus
                  disabled={loading}
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div className="form-group">
                <label>Confirmar nova senha</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                  disabled={loading}
                  placeholder="Repita a nova senha"
                />
              </div>
              <button type="submit" className="auth-btn" disabled={loading || !password || !confirm}>
                {loading ? 'Salvando...' : 'Salvar nova senha'}
              </button>
            </form>
          )}

          <div className="auth-footer" style={{ marginTop: 16 }}>
            <Link to="/login">← Voltar para o login</Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
